module.exports = __webpack_public_path__ + "static/media/timer.a1dc0a2a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/timer.svg
// module id = 1890
// module chunks = 0